import React from "react";
import { CautionSvg } from "../Icons";
import CustomModal from "../../CustomModal/CustomModal";
import Loader from "../Components/Loader";

const DeleteModal = ({
  isBin = false,
  open,
  close,
  handleDelete,
  fileName = "",
  primaryLabel = "Delete",
  secondaryLabel = "Cancel",
  selectedKeys = [],
  loading = false,
}) => {
  const count = selectedKeys?.length || 0;
  const fileText = count === 1 ? "1 file" : `${count} files`;
  const isMultiple = count > 0 && !fileName;

  const titleText = isMultiple
    ? isBin
      ? `Delete ${fileText} permanently`
      : `Move ${fileText} to Bin`
    : isBin
    ? `Delete ${fileName} permanently`
    : `Move ${fileName} to Bin`;

  const bodyText = isMultiple
    ? isBin
      ? `${fileText} will be deleted permanently.`
      : `${fileText} will be moved to bin. You can restore it later if needed.`
    : isBin
    ? `${fileName} will be deleted permanently.`
    : `${fileName} will be moved to bin. You can restore it later if needed.`;

  return (
    <CustomModal
      open={open}
      justifyFooter="center"
      width={700}
      onClose={close}
      primaryClick={handleDelete}
      primaryLabel={!loading ? primaryLabel : null}
      secondaryLabel={!loading ? secondaryLabel : null}
      secondaryClick={close}
      primaryDisbaled={loading}
    >
      <div className="w-full flex flex-col items-center justify-center gap-2 overflow-auto">
        {loading ? (
          <Loader />
        ) : (
          <>
            <CautionSvg />
            <div className="font-medium text-[1rem] text-[#000000] break-words max-w-full">{titleText}</div>
            <div className="font-normal text-[0.8rem] text-[#000000] break-words max-w-full">{bodyText}</div>
          </>
        )}
      </div>
    </CustomModal>
  );
};

export default DeleteModal;